import React from 'react';
import { Tooltip } from 'antd';
import { Colors } from '@common/tokens';

export const ValueWithOriginal = ({
  label,
  value,
  original,
  suffix = '',
}: {
  label: string;
  value: string;
  original?: string;
  suffix?: string;
}) => {
  if (!original || value === original) {
    return value;
  }

  return (
    <>
      <Tooltip
        placement="bottom"
        title={`Original ${label}: ${original} ${suffix}`}
      >
        <span>
          {value} {suffix}
        </span>
      </Tooltip>

      <style jsx>{`
        span {
          color: ${Colors.grass};
        }
      `}</style>
    </>
  );
};
